import { render, staticRenderFns } from "./customerRepresentativeIcon.vue?vue&type=template&id=5b2a95d1&scoped=true"
import script from "./customerRepresentativeIcon.vue?vue&type=script&lang=js"
export * from "./customerRepresentativeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a95d1",
  null
  
)

export default component.exports